module.exports = __webpack_public_path__ + "media/images/icons/volunteer-74d3ba209895ea433cd585e4effec5a0.svg";